<template>
	<div class="reason-option" @click="$emit('click')">
		<div class="reason-option-main flex-center" :class="{'z-crt': selected}">
			<div class="flex-center"><i class="tf c-icon-check"></i></div>
			<p class="flex-grow ellipsis">{{name}}</p>
		</div>

		<div v-if="$slots.default" class="reason-option-handle">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'reasonOption',

		props: {
			selected: Boolean,
			name: String
		}
	}
</script>

<style lang="stylus" scoped>
	.reason-option {
		overflow: hidden;

		&:nth-child(even) {
			background: #F9F9F9;
		}

		&-main {
			gap: .26rem;
			height: 1rem;
			padding: 0 .32rem;
			font-size: .3rem;

			div {
				box-sizing: border-box;
				width: .42rem;
				height: .42rem;
				border: .03rem solid #ccc;
				border-radius: 50%;
				font-size: .26rem;
				color: #fff;
				background: #fff;
				box-shadow: .02rem .03rem .06rem 0 rgba(0,0,0,.1);

				^[-1].z-crt ^[-1..-1] {
					border-color: var(--color-main);
					background: var(--color-main);
				}
			}

			p {
				^[-1].z-crt ^[-1..-1] {
					font-weight: bold;
				}
			}
		}

		&-handle {
			margin: 0 .32rem .2rem 1rem;
		}
	}
</style>
